type NetworkStatusHandlers = {
  handleOffline: () => void;
  handleOnline: () => {};
};

export const useNetworkStatus = ({ handleOffline, handleOnline }: NetworkStatusHandlers) => {
  const setupNetworkListeners = () => {
    window?.addEventListener('online', handleOnline);
    window?.addEventListener('offline', handleOffline);
  };

  const cleanupNetworkListeners = () => {
    window?.removeEventListener('online', handleOnline);
    window?.removeEventListener('offline', handleOffline);
  };

  return {
    cleanupNetworkListeners,
    setupNetworkListeners,
  };
};
